export default __webpack_public_path__ + "static/media/leaves-gec19df3f6_1280.92afbb58.jpg";